import { useMemo, useState } from "react"

import { SearchOutlined } from "@ant-design/icons"
import { Flex, Select } from "antd"

import InputComponent from "../../../Input"

import "./styles.less"

const CountrySelect = ({ countries, value, disabled, onChange }) => {
  const [query, setQuery] = useState("")
  const [open, setOpen] = useState(false)

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase()
    if (!q) return countries
    return countries.filter((c) => {
      const hay = `${c.name} ${c.dial} ${c.iso2}`.toLowerCase()
      return hay.includes(q)
    })
  }, [countries, query])

  return (
    <Select
      value={value}
      onChange={onChange}
      className={`pc-select${open ? "-open" : ""}`}
      popupClassName="pc-dropdown"
      getPopupContainer={() => document.getElementById("main-layout") || document.body}
      popupMatchSelectWidth={320}
      showSearch={false}
      optionLabelProp="label"
      disabled={disabled}
      onDropdownVisibleChange={(open) => setOpen(open)}
      dropdownRender={(menu) => (
        <div className="pc-dropdown__wrap">
          <div className="pc-dropdown__search">
            <InputComponent
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search country..."
              prefix={<SearchOutlined />}
              className="pc-dropdown__input"
              autoFocus
            />
          </div>

          <div className="pc-dropdown__menu">{menu}</div>
        </div>
      )}
    >
      {Array.isArray(filtered) &&
        filtered?.map((c) => (
          <Select.Option
            key={c.id}
            value={c.name}
            label={
              <Flex
                size={8}
                align="center"
                gap={8}
                style={{ width: 64, paddingLeft: !open ? 10 : 0 }}
              >
                <span className="pc-flag">
                  <img src={c.flag} />
                </span>
                <span className="pc-dial">+{c.code}</span>
              </Flex>
            }
          >
            <div className="pc-option">
              <div className="pc-option__left">
                <span className="pc-flag">
                  <img src={c.flag} />
                </span>
                <span className="pc-name">{c.name}</span>
              </div>
              <span className="pc-dial pc-dial--muted">+{c.code}</span>
            </div>
          </Select.Option>
        ))}
    </Select>
  )
}

export default CountrySelect
